import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { AnalyticsPeriod, AnalyticsPeriodUtil } from '../../../models/enums/analyticsPeriod';

interface PeriodFormControlProps {
    name: string;
    label?: string;
    required?: boolean;
    disabled?: boolean;
}

export const PeriodFormControl: React.FC<PeriodFormControlProps> = ({
    name,
    label = 'Период анализа',
    required = true,
    disabled = false
}) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            rules={{ required: required ? 'Обязательное поле' : false }}
            render={({ field, fieldState }) => (
                <FormControl fullWidth size="small" error={!!fieldState.error} disabled={disabled} required={required}>
                    <InputLabel 
                        required={required}
                        sx={{ 
                            whiteSpace: 'nowrap',
                            overflow: 'visible',
                            textOverflow: 'clip',
                            maxWidth: 'none'
                        }}
                    >
                        {label}
                    </InputLabel>
                    <Select
                        {...field}
                        label={label}
                        disabled={disabled}
                        required={required}
                        renderValue={(value) => AnalyticsPeriodUtil.getStringValue(value as AnalyticsPeriod)}
                    >
                        <MenuItem value={AnalyticsPeriod.Day}>{AnalyticsPeriodUtil.getStringValue(AnalyticsPeriod.Day)}</MenuItem>
                        <MenuItem value={AnalyticsPeriod.Month}>{AnalyticsPeriodUtil.getStringValue(AnalyticsPeriod.Month)}</MenuItem>
                    </Select>
                    {fieldState.error && (
                        <FormHelperText>{fieldState.error.message}</FormHelperText>
                    )}
                </FormControl>
            )}
        />
    );
};

